import React, { useState } from "react";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";
import { setCookieConsent } from "@/lib/attribution";

export const ConsentBanner = () => {
  const [visible, setVisible] = useState(() => !localStorage.getItem('cookieConsent'));
  if (!visible) return null;
  const choose = (choice) => { setCookieConsent(choice); setVisible(false); };
  return (
    <div className="fixed bottom-4 left-3 right-3 lg:left-auto lg:right-4 lg:max-w-md z-50 bg-white/95 backdrop-blur-sm border border-gray-200 shadow-xl rounded-xl p-3" data-testid="cookie-banner">
      <div className="flex items-center justify-between gap-3">
        <p className="text-xs text-gray-600"><Cookie className="w-3 h-3 inline mr-1 text-amber-500" />Nous utilisons des cookies de mesure Google Ads, seulement si vous acceptez.</p>
        <div className="flex gap-1.5 flex-shrink-0">
          <Button variant="outline" onClick={() => choose('essential')} size="sm" className="h-7 px-3 text-xs rounded-full" data-testid="cookie-reject">Refuser</Button>
          <Button onClick={() => choose('all')} size="sm" className="h-7 px-3 text-xs bg-green-600 hover:bg-green-700 rounded-full" data-testid="cookie-accept">Accepter</Button>
        </div>
      </div>
    </div>
  );
};
